var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripButton } from './grip-button';
var cls = classNames('option-menu-input-selection');
export var OptionMenuInputSelectionDefaultProps = {
  menuProps: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(1))
});
var HandleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    /* cursor: grab; */\n  "], ["\n    /* cursor: grab; */\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenuInputSelection',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Handle: styled(GripButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), HandleStyles)
};
export var OptionMenuInputSelection = function (props) {
  var componentProps = useComponentProps(My.NAME, OptionMenuInputSelectionDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    item = componentProps.item,
    style = componentProps.style,
    isGhost = componentProps.isGhost,
    menu = componentProps.menu,
    menuProps = componentProps.menuProps,
    onMenuItemSelect = componentProps.onMenuItemSelect;
  var _a = useSortable({
      id: item.id
    }),
    attributes = _a.attributes,
    listeners = _a.listeners,
    setNodeRef = _a.setNodeRef,
    transform = _a.transform,
    transition = _a.transition;
  // console.log(transform, transition);
  var newTransform = __assign({}, transform);
  // prevent squishing as we drag
  if (transform === null || transform === void 0 ? void 0 : transform.scaleX) {
    newTransform.scaleX = 1;
  }
  return React.createElement(My.Container, {
    ref: setNodeRef,
    style: __assign(__assign({
      opacity: isGhost ? 0.5 : 1
    }, style), {
      transform: CSS.Transform.toString(transform ? newTransform : undefined),
      transition: transition
    }),
    className: cls.name(className)
  }, React.createElement(My.Handle, __assign({
    title: 'Drag to reorder, click for menu',
    menu: menu,
    onMenuItemSelect: onMenuItemSelect,
    menuProps: menuProps
  }, attributes, listeners)), children);
};
OptionMenuInputSelection.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;